import { defineMessages } from 'react-intl';

export default defineMessages({
    delete: {
        id: 'modal.delete',
        defaultMessage: 'Delete',
    },
})
